<svg
  class="block size-full"
  fill="none"
  preserveAspectRatio="none"
  viewBox="0 0 24 24"
  [attr.width]="width ?? size"
  [attr.height]="height ?? size"
>
  <g id="play">
    <path
      d="M5 4.98963C5 4.01846 5 3.53288 5.20249 3.26521C5.37889 3.03202 5.64852 2.88772 5.9404 2.8703C6.27544 2.85029 6.67946 3.11964 7.48752 3.65835L18.0031 10.6687C18.6708 11.1138 19.0046 11.3364 19.1209 11.6169C19.2227 11.8622 19.2227 12.1378 19.1209 12.3831C19.0046 12.6636 18.6708 12.8862 18.0031 13.3313L7.48752 20.3417C6.67946 20.8804 6.27544 21.1497 5.9404 21.1297C5.64852 21.1123 5.37889 20.968 5.20249 20.7348C5 20.4671 5 19.9815 5 19.0104V4.98963Z"
      id="Icon"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="2"
    ></path>
  </g>
</svg>
